// 🔹 Normalization helpers
function normalizePhone(phone) {
  if (!phone) return "";

  let normalized = phone.replace(/[\s\-()]/g, "");

  if (normalized.startsWith("+")) {
    normalized = normalized.substring(1);
  }

  if (normalized.startsWith("0")) {
    normalized = "966" + normalized.substring(1);
  }

  return normalized;
}

function normalizeEmail(email) {
  if (!email) return "";
  return email.trim().toLowerCase();
}

// 🔹 Hashing function
async function sha256(value) {
  const encoder = new TextEncoder();
  const data = encoder.encode(value);
  const hashBuffer = await crypto.subtle.digest("SHA-256", data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map(b => b.toString(16).padStart(2, "0")).join("");
}

// 🔹 Main function
const pushFormSubmitEvent = async ({ id, userPhone, userEmail, destination, formLength = 0 }) => {
  try {
    const normalizedPhone = normalizePhone(userPhone);
    const normalizedEmail = normalizeEmail(userEmail);

    const hashedPhone = normalizedPhone ? await sha256(normalizedPhone) : "";
    const hashedEmail = normalizedEmail ? await sha256(normalizedEmail) : "";

    if (window?.dataLayer) {
      window.dataLayer.push({
        event: "lead-generated",
        form_id: id || "",
        hashed_phone_number: hashedPhone,
        hashed_email: hashedEmail,
        form_destination: destination,
        form_length: formLength,
        event_callback: () => {
          console.log("Event Model Callback ✅");
        },
        send_to: "G-D68FBHYS9E",
        eventCallback: () => {
          console.log("Form Submit Event Sent to GTM ✅");
        },
      });
    } else {
      console.warn("⚠️ dataLayer not found on window");
  }
  } catch (err) {
    console.error("Hashing Error ❌", err);
  }
};

export default pushFormSubmitEvent;
